import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useSignIn } from "./SignInHook";
const SignInContext = /*#__PURE__*/createContext({});
export const SignInContextProvider = ({
  children
}) => {
  const signInHook = useSignIn();
  const {
    stateTracker
  } = useDevLogging();
  const signInContext = useMemo(() => {
    stateTracker.trackState({
      signIn: signInHook
    });
    return {
      ...signInHook
    };
  }, [signInHook.loading, signInHook.password, signInHook.email, signInHook.passwordResetError, signInHook.forgotPasswordError, signInHook.signUpState]);
  return /*#__PURE__*/React.createElement(SignInContext.Provider, {
    value: signInContext
  }, children);
};
export const useSignInContext = () => {
  return useContext(SignInContext);
};
SignInContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};